import {
  Component,
  ViewChild,
  OnInit,
  OnDestroy,
  ElementRef,
  AfterViewInit,
  HostListener,
} from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Observable, combineLatest, BehaviorSubject } from "rxjs";
import {
  map,
  filter,
  withLatestFrom,
  distinctUntilChanged,
  startWith,
  take,
} from "rxjs/operators";
import { AppState } from "../../reducers";
import {
  selectAuthLoggedIn,
  selectAuthUserType,
  selectAuthUserCountry,
  selectAuthUserRole,
} from "../../features/auth/auth.selectors";
import { selectCurrentRoute } from "../../global/app-routing.selectors";
import { Subscription } from "rxjs";
import {
  selectMainFilterClient,
  selectMainFilterAccount,
  selectMainFilterSelectedClient,
  selectMainClients,
  selectMainFilterSelectedAccount,
  selectMainFilter,
  selectCountrySelected,
} from "./main.selectors";
import {
  SetMainFilterAccountAction,
  SetMainFilterAction,
  LoadMainClientsAction,
  LoadStaticDataAction,
  LoadPageNotesAction,
} from "./main.actions";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { Client, Account } from "./main.models";
import { WindowResizeService } from "../../global/window-resize.service";
import {
  LoadValuationsDatesAction,
  ResetValuationsDataAction,
  ResetValuationsFilterAction,
} from "../../features/valuations/valuations.actions";
import { ResetReportsDataAction } from "../../features/reports/reports.actions";
import { checkBrowserVersion } from "../../global/browsers";
// import { AddWarningToastAction } from '../../features/toaster/toaster.actions';
import { isEqual } from "lodash";
import {
  ResetTransactionsMobileData,
  ResetTransactionsMobilePagination,
} from "../../features/transactions/transactions.actions";
import { ResetStatementsAction } from "../../features/statements/statements.actions";
import {
  ResetDocumentsAction,
  SetDocumentsFromFilterAction,
} from "../../features/documents/documents.actions";
import { isNullOrUndefined } from "util";
import { FieldComponent, HaloSelectComponent, FieldSelectOption, FieldSize } from "atlas-field";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewEncapsulation,
} from "@angular/core";
import {
  AtlasLegacyNavigationItem,
  ShowHideState,
} from "atlas-legacy";
import { AppNavigationComponent } from "./app-navigation.component";
import { ToastService } from "../toaster_/toaster_.service";
// import { MosShowHideState, MosAppNavComponent, MosMultiSelectComponent } from 'merceros-ui-components';
import { Actions as ActionsCDK } from "atlas-cdk";

@Component({
  standalone: false,
  selector: "dsp-main",
  templateUrl: "main.component.html",
  styleUrls: ["main.component.scss"],
})
export class MainComponent implements OnInit, OnDestroy, AfterViewInit {
  // @ViewChild(MosAppNavComponent)
  // public nav: MosAppNavComponent;

  @ViewChild(AppNavigationComponent)
  public nav: AppNavigationComponent;

  @ViewChild("scrollTarget")
  public scrollTarget: ElementRef;

  @ViewChild("scrollContainer")
  public scrollContainer: ElementRef;

  // @ViewChild('clientSelect')
  // public clientSelect: MosMultiSelectComponent;

  // @ViewChild('accountSelect')
  // public accountSelect: MosMultiSelectComponent;

  @ViewChild("clientSelect")
  public clientSelect: Boolean = true;

  @ViewChild("accountSelect")
  public accountSelect: HaloSelectComponent;

  public clientFilterAt: Client;

  public accountFilterAt: Account;

  // public showNav$: Observable<ShowHideState>;
  public showNav$: Observable<ShowHideState>;

  // public navigation$: Observable<MosNavigationItem[]>;
  // public botNavigation$: Observable<MosNavigationItem[]>;
  public navigation$: Observable<AtlasLegacyNavigationItem[]>;
  public botNavigation$: Observable<AtlasLegacyNavigationItem[]>;
  public showSecondaryHeader$: Observable<boolean>;
  public showFilter$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public showHeader$: Observable<boolean>;
  public logged$: Observable<boolean>;
  public page$: Observable<string>;
  public admin$: Observable<boolean>;
  public clients$: Observable<Client[]>;
  public accounts$: Observable<Account[]>;
  public clientOptions$: Observable<FieldSelectOption[]>;
  public accountOptions$: Observable<FieldSelectOption[]>;
  public clientSelectedId: string | null = null;
  public accountSelectedId: string | null = null;
  public heroSize$: BehaviorSubject<number> = new BehaviorSubject(180);
  public screenHeight$: BehaviorSubject<number> = new BehaviorSubject(0);
  public showScrollToTop$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  public isMobile$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public mobileScrollHeight$: BehaviorSubject<string> = new BehaviorSubject(
    "calc(100vh - 90px)"
  );
  public accounts: Array<Account> = new Array<Account>();
  public showHelpBox = false;
  public showResourceCenter: boolean;

  public navigation: AtlasLegacyNavigationItem[] = [
    {
      path: "/overview",
      name: "Overview",
      icon: "grid-view",
      iconCollection: "user-interface-solid",
      active: true,
    },
    {
      path: "/valuation",
      name: "Valuation",
      icon: "trend-up",
      iconCollection: "arrows-solid",
    },
    {
      path: "/performance",
      name: "Performance",
      icon: "statistics",
      iconCollection: "business-finance-solid",
    },
    {
      path: "/holdings",
      name: "Holdings",
      icon: "a-chart",
      iconCollection: "user-interface-solid",
    },
    {
      path: "/esg",
      name: "Sustainable Investment",
      icon: "money-bag",
      iconCollection: "gaming-solid",
    },
    {
      path: "/cash-flow",
      name: "Cash Flow Summary",
      icon: "round-dollar",
      iconCollection: "business-finance-solid",
    },
    {
      path: "/tax-details",
      name: "Tax Details",
      icon: "coins",
      iconCollection: "business-finance-solid",
    },
    {
      path: "/transactions",
      name: "Transactions",
      icon: "transaction",
      iconCollection: "arrows-solid",
    },
    {
      path: "/statements",
      name: "Statements",
      icon: "bank-statement",
      iconCollection: "business-finance-solid",
    },
    {
      path: "/documents",
      name: "Documents",
      icon: "document-copy",
      iconCollection: "files-folders-solid",
    },
    {
      path: "/reports",
      name: "Reports",
      icon: "notes",
      iconCollection: "business-finance-solid",
    },
  ];

  public botNavigation: AtlasLegacyNavigationItem[] = [
    // { path: '/about', name: 'About', icon: 'info_outline' },
    {
      path: "/contacts",
      name: "Contacts",
      icon: "headphones",
      iconCollection: "multimedia-solid",
    },
  ];

  public scrollPages: string[] = [
    "Overview",
    "Valuation",
    "Performance",
    "Holdings",
    "Cash Flow Summary",
    "Transactions",
  ];
  public otherPages: string[] = ["Profile"];
  public adminPages: string[] = ["Administration"];
  public mobileNav: string[] = [
    "Overview",
    "Valuation",
    "Performance",
    "Cash Flow Summary",
    "Transactions",
    "Statements",
    "Documents",
  ];
  public mobileBotNav: string[] = ["Contacts"];
  sizeMedium = FieldSize.medium;
  sizeSmall = FieldSize.small;

  public subscription: Subscription = new Subscription();

  public constructor(
    private readonly store: Store<AppState>,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly resize: WindowResizeService,
    // private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _toasterService: ToastService
  ) {
    // const isDisabled = (`${!(CONFIG.API_URL.includes('stage'))}` && environment.APP_ENV === 'production') ? true : false;
    // this.showResourceCenter = isDisabled ? false : true;
    this.logged$ = this.store.pipe(select(selectAuthLoggedIn));
    this.showNav$ = this.selectShowNav();
    this.admin$ = this.selectAdmin();
    this.clients$ = this.selectClients();
    this.accounts$ = this.selectAccounts();
    this.clientOptions$ = this.clients$.pipe(
      map(clients => clients ? clients.map(c => ({ label: c.name, value: c._id })) : [])
    );
    this.accountOptions$ = this.accounts$.pipe(
      map(accounts => accounts ? accounts.map(a => ({ label: a.display || `${a.number} - ${a.name}`, value: a._id })) : [])
    );
    this.showSecondaryHeader$ = this.selectShowSecondaryHeader();
    this.showHeader$ = this.selectShowHeader();
    this.navigation$ = this.selectNavigation();
    this.botNavigation$ = this.selectBotNavigation();
    this.page$ = this.selectCurrentPage();
  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribeIsMobile());
    this.subscription.add(this.subscribeLoadClients());
    this.subscription.add(this.subscribeFilters());
    this.subscription.add(this.subscribeClientFilter());
    this.subscription.add(this.subscribeAccountFilter());
    this.subscription.add(this.subscribeLoadStaticData());
    this.subscription.add(this.subscribeAccountChange());
    this.subscription.add(this.subscribeScreenHeight());
    this.subscription.add(this.subscribeHeroSize());
    this.subscription.add(this.subscribeMobileScrollHeight());
    this.subscription.add(this.subscribePageNotes());
    this.subscription.add(this.selectShowFilter());

    this.checkBrowserVersion();
  }

  public ngAfterViewInit(): void {
    this.subscription.add(this.subscribeScrollToTop());
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('document:wheel', ['$event'])
  public onBackdropWheel(event: WheelEvent): void {
    const target = event.target as HTMLElement;
    const isNonBlockingBackdrop =
      target.classList.contains('cdk-overlay-transparent-backdrop') ||
      target.classList.contains('select-backdrop');
    if (isNonBlockingBackdrop && this.scrollContainer?.nativeElement) {
      this.scrollContainer.nativeElement.scrollBy({ top: event.deltaY, left: event.deltaX });
    }
  }

  // noinspection JSMethodCanBeStatic
  public formatDropdownLabel(account: Account): string {
    return `${account.number} - ${account.name}`;
  }

  // public onChangeClient(event: Client[]): void {
  //   if (event.length) {
  //     this.store.pipe(
  //       select(selectMainFilter),
  //       take(1)
  //     ).subscribe(filter => {
  //       if (!filter.client.length || event[0]._id !== filter.client[0]._id) {
  //         event[0].accounts = event[0].accounts.sort((a, b) => a.name.localeCompare(b.name));
  //         const account = event[0].accounts.length > 0 ? event[0].accounts[0] : undefined;
  //         this.store.dispatch(new SetMainFilterAction({
  //           client: event,
  //           account: !!account ? [{ ...account, display: this.formatDropdownLabel(account) }] : []
  //         }));
  //         this.clientSelect.isOpen = false;
  //       }
  //     });
  //   }
  // }

  public onChangeClientAt(event: Client): void {

    if (event) {
      this.store.pipe(select(selectMainFilter), take(1)).subscribe((filter) => {
        if (!filter.client.length || event._id !== filter.client[0]._id) {
          event.accounts = event.accounts.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
          const account =
            event.accounts.length > 0 ? event.accounts[0] : undefined;
          this.store.dispatch(
            new SetMainFilterAction({
              client: [event],
              account: !!account
                ? [{ ...account, display: this.formatDropdownLabel(account) }]
                : [],
            })
          );
          this.clientSelect = false;
        }
      });
    }
  }

  public onChangeAccountAt(event: Account): void {
    if (event) {
      this.store
        .pipe(select(selectMainFilterAccount), take(1))
        .subscribe((filterAccount) => {

          if (!filterAccount.length || filterAccount[0]._id !== event._id) {
            this.store.dispatch(new SetMainFilterAccountAction([event]));
          }
        });
    }
  }

  // public onChangeAccount(event: Account[]): void {
  //   if (event.length) {
  //     this.store.pipe(
  //       select(selectMainFilterAccount),
  //       take(1)
  //     ).subscribe(filterAccount => {
  //       if (!filterAccount.length || filterAccount[0]._id !== event[0]._id) {
  //         this.accountFilter = event;
  //         this.store.dispatch(new SetMainFilterAccountAction(event));
  //       }
  //       // this.accountSelect.isOpen = false;
  //     });
  //   }
  //   if (this.accountFilter.length === 2) {
  //     event.shift();
  //   }
  // }

  public compareAccounts(a1: Account, a2: Account): boolean {
    return a1 && a2 ? a1._id === a2._id : a1 === a2;
  }

  public onScrollToTop(): void {
    if (!!this.scrollTarget.nativeElement) {
      this.scrollTarget.nativeElement.scrollIntoView();
    }
  }

  public openHelp(): void {
    this.showHelpBox = true;
  }

  public onshowHelpBoxEvent(event): void {
    this.showHelpBox = event;
  }

  public onScroll(): void {
    this.page$.pipe(take(1)).subscribe((page) => {
      if (
        this.scrollPages.includes(page) &&
        this.scrollContainer.nativeElement.scrollTop > 200
      ) {
        this.showScrollToTop$.next(true);
      } else {
        this.showScrollToTop$.next(false);
      }
    });
  }

  private collapseNavbar(): void {
    if (!isNullOrUndefined(this.nav)) {
      this.nav.setSideNavExpanded(false);
    }
  }

  private selectAdmin(): Observable<boolean> {
    return combineLatest([
      this.store.pipe(select(selectAuthUserType)),
      this.store.pipe(select(selectAuthUserRole)),
    ]).pipe(
      filter(([type, role]) => !!type && !!role),
      map(([type, role]) => {
        if (type === "internal") {
          return true;
        }
        if (type === "external" && role === "consultant") {
          return true;
        }
      })
    );
  }

  // private selectShowNav(): Observable<MosShowHideState> {
  //   return this.logged$.pipe(
  //     map(logged => {
  //       if (logged) {
  //         return MosShowHideState.Show;

  //       } else {
  //         this.collapseNavbar();
  //         return MosShowHideState.Hide;
  //       }
  //     })
  //   );
  // }

  private selectShowNav(): Observable<ShowHideState> {
    return this.logged$.pipe(
      map((logged) => {
        if (logged) {
          return ShowHideState.Show;
        } else {
          this.collapseNavbar();
          return ShowHideState.Hide;
        }
      })
    );
  }

  private selectNavigation(): Observable<AtlasLegacyNavigationItem[]> {
    // return combineLatest(
    //   this.isMobile$,
    //   this.store.pipe(select(selectAuthUserType)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectCountrySelected))
    // ).pipe(
    return combineLatest([
      this.isMobile$,
      this.store.pipe(select(selectAuthUserType)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectCountrySelected)),
      this.store.pipe(select(selectAuthUserRole)),
    ]).pipe(
      map(([isMobile, selectAuthUserType, selectedClient, country, role]) => {
        if (isMobile) {
          return this.navigation.filter((page) =>
            this.mobileNav.includes(page.name)
          );
        } else {
          if (country === "au") {
            if (
              selectAuthUserType === "external" &&
              (isNullOrUndefined(selectedClient) ||
                (!isNullOrUndefined(selectedClient) &&
                  (isNullOrUndefined(selectedClient.esg) ||
                    selectedClient.esg === false)))
            ) {
              return this.navigation.filter(
                (navItem) =>
                  !(navItem.path === "/esg" || navItem.path === "/tax-details")
              );
            } else {
              return this.navigation.filter(
                (navItem) => !(navItem.path === "/tax-details")
              );
            }
          }
          if (country === "nz") {
            if (
              selectAuthUserType === "external" &&
              role !== "consultant" &&
              (isNullOrUndefined(selectedClient) ||
                (!isNullOrUndefined(selectedClient) &&
                  (isNullOrUndefined(selectedClient.esg) ||
                    selectedClient.taxDetail === false)))
            ) {
              return this.navigation.filter(
                (navItem) =>
                  !(navItem.path === "/tax-details" || navItem.path === "/esg")
              );
            } else if (
              selectAuthUserType === "external" &&
              role === "consultant" &&
              (isNullOrUndefined(selectedClient) ||
                (!isNullOrUndefined(selectedClient) &&
                  (isNullOrUndefined(selectedClient.taxDetail) ||
                    selectedClient.taxDetail === false)))
            ) {
              return this.navigation.filter(
                (navItem) =>
                  !(navItem.path === "/tax-details" || navItem.path === "/esg")
              );
            } else {
              return this.navigation.filter(
                (navItem) => !(navItem.path === "/esg")
              );
            }
          }
        }
      })
    );
  }

  private selectBotNavigation(): Observable<AtlasLegacyNavigationItem[]> {
    return this.isMobile$.pipe(
      map((isMobile) => {
        if (isMobile) {
          const filtered = this.botNavigation.filter((page) =>
            this.mobileBotNav.includes(page.name)
          );

          return filtered.map((item) => {
            if (this.mobileBotNav.includes(item.name)) {
              return { ...item, name: "Contacts" };
            }

            return item;
          });
        } else {
          return this.botNavigation;
        }
      })
    );
  }

  // private selectNavigation(): Observable<MosNavigationItem[]> {
  //   // return combineLatest(
  //   //   this.isMobile$,
  //   //   this.store.pipe(select(selectAuthUserType)),
  //   //   this.store.pipe(select(selectMainFilterSelectedClient)),
  //   //   this.store.pipe(select(selectCountrySelected))
  //   // ).pipe(
  //   return combineLatest([
  //     this.isMobile$,
  //     this.store.pipe(select(selectAuthUserType)),
  //     this.store.pipe(select(selectMainFilterSelectedClient)),
  //     this.store.pipe(select(selectCountrySelected)),
  //     this.store.pipe(select(selectAuthUserRole))
  //   ]).pipe(
  //     map(([isMobile, selectAuthUserType, selectedClient, country, role]) => {
  //       if (isMobile) {
  //         return this.navigation.filter(page => this.mobileNav.includes(page.name));
  //       } else {
  //         if (country === 'au') {
  //           if (selectAuthUserType === 'external'
  //             && ((isNullOrUndefined(selectedClient)) || (!isNullOrUndefined(selectedClient)
  //               && (isNullOrUndefined(selectedClient.esg) || selectedClient.esg === false)))) {
  //             return this.navigation.filter(navItem => !(navItem.path === '/esg' || navItem.path === '/tax-details'));
  //           } else {
  //             return this.navigation.filter(navItem => !(navItem.path === '/tax-details'));
  //           }
  //         }
  //         if (country === 'nz') {
  //           if (selectAuthUserType === 'external' && role !== 'consultant' &&
  //             ((isNullOrUndefined(selectedClient)) || (!isNullOrUndefined(selectedClient) &&
  //               (isNullOrUndefined(selectedClient.esg) || selectedClient.taxDetail === false)))) {
  //             return this.navigation.filter(navItem => !(navItem.path === '/tax-details' || navItem.path === '/esg'));
  //           } else if (selectAuthUserType === 'external' && role === 'consultant' &&
  //             ((isNullOrUndefined(selectedClient)) || (!isNullOrUndefined(selectedClient) &&
  //               (isNullOrUndefined(selectedClient.taxDetail) || selectedClient.taxDetail === false)))) {
  //             return this.navigation.filter(navItem => !(navItem.path === '/tax-details' || navItem.path === '/esg'));
  //           } else {
  //             return this.navigation.filter(navItem => !(navItem.path === '/esg'));
  //           }
  //         }
  //       }
  //     })
  //   );
  // }

  // private selectBotNavigation(): Observable<MosNavigationItem[]> {
  //   return this.isMobile$.pipe(
  //     map(isMobile => {
  //       if (isMobile) {
  //         const filtered = this.botNavigation.filter(page => this.mobileBotNav.includes(page.name));

  //         return filtered.map(item => {
  //           if (this.mobileBotNav.includes(item.name)) {
  //             return { ...item, name: 'Contacts' };
  //           }

  //           return item;
  //         });
  //       } else {
  //         return this.botNavigation;
  //       }
  //     })
  //   );
  // }

  private selectClients(): Observable<Client[]> {
    return this.store.pipe(select(selectMainClients));
  }

  private selectAccounts(): Observable<Account[]> {
    const accounts = this.store.pipe(
      select(selectMainFilterSelectedClient),
      map((client) =>
        !client
          ? []
          : client.accounts
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((account: Account) => ({
              ...account,
              displayName: this.getDisplayName(account),
              display: this.formatDropdownLabel(account),
            }))
      )
    );
    accounts.subscribe((x) => (this.accounts = x));
    return accounts;
  }

  private getDisplayName(account): String {
    return `${account.number} - ${account.name}`;
  }

  private selectShowSecondaryHeader(): Observable<boolean> {
    return this.store.pipe(
      select(selectCurrentRoute),
      withLatestFrom(this.logged$),
      map(
        ([page, logged]) =>
          logged &&
          !page.includes("administration") &&
          !page.includes("profile")
      )
    );
  }

  private selectShowFilter(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectCurrentRoute)),
      this.logged$,
    ])
      .pipe(
        map(
          ([page, logged]) =>
            logged &&
            !page.includes("about") &&
            !page.includes("contacts") &&
            !page.includes("profile")
        )
      )
      .subscribe(this.showFilter$);
  }
  private selectShowHeader(): Observable<boolean> {
    return this.store.pipe(
      select(selectCurrentRoute),
      withLatestFrom(this.logged$),
      map(
        ([page, logged]) =>
          logged && !page.includes("about") && !page.includes("contacts")
      )
    );
  }

  /**
   * Check if current route matches any links in primary navigation
   * or other pages that are not present in primary or secondary navigation
   * If a match is found, emits page name as formatted string
   */
  private selectCurrentPage(): Observable<string> {
    // return combineLatest(
    //   this.logged$,
    //   this.store.pipe(select(selectCurrentRoute)),
    //   this.botNavigation$
    // ).pipe(
    return combineLatest([
      this.logged$,
      this.store.pipe(select(selectCurrentRoute)),
      this.botNavigation$,
    ]).pipe(
      filter(([logged, route]) => !!route),
      map(([logged, route, botNav]) => {
        const link = this.navigation.find((item) => route.includes(item.path)),
          otherPage = this.otherPages.find((item) =>
            route.includes(item.toLowerCase())
          ),
          adminPage = this.adminPages.find((item) =>
            route.includes(item.toLowerCase())
          );
        if (!!otherPage) {
          return { name: `My ${otherPage}` };
        } else if (!!adminPage) {
          return { name: `${adminPage}` };
        } else {
          return !!link
            ? link
            : botNav.find((item) => route.includes(item.path));
        }
      }),
      filter((item) => !!item),
      map((item) => item.name)
    );
  }

  private subscribeLoadClients(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectAuthLoggedIn)),
    //   this.store.pipe(select(selectCountrySelected))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectAuthLoggedIn)),
      this.store.pipe(select(selectCountrySelected)),
    ])
      .pipe(
        filter(([logged, country]) => !!logged && !!country),
        map(([logged, country]) => ({ logged, country }))
      )
      .subscribe((payload) => {
        this.store.dispatch(new LoadMainClientsAction(payload)); // TO DO : REVIEW
      });
  }

  private subscribeLoadStaticData(): Subscription {
    return this.store
      .pipe(
        select(selectCountrySelected),
        filter((country) => !!country),
        distinctUntilChanged(isEqual)
      )
      .subscribe((country) => {
        this.store.dispatch(new LoadStaticDataAction(country as string));
      });
  }

  private subscribeClientFilter(): Subscription {
    return this.store
      .pipe(select(selectMainFilterClient))
      .subscribe((client) => {
        this.clientFilterAt = client[0];
        this.clientSelectedId = client[0]?._id ?? null;
      });
  }
  private subscribeAccountFilter(): Subscription {
    return this.store
      .pipe(select(selectMainFilterAccount))
      .subscribe((account) => {
        this.accountFilterAt = account[0];
        this.accountSelectedId = account[0]?._id ?? null;
      });
  }

  public onClientSelectChange(selectedId: string): void {
    this.clients$.pipe(take(1)).subscribe(clients => {
      const client = clients.find(c => c._id === selectedId);
      if (client) {
        this.onChangeClientAt(client);
      }
    });
  }

  public onAccountSelectChange(selectedId: string): void {
    this.accounts$.pipe(take(1)).subscribe(accounts => {
      const account = accounts.find(a => a._id === selectedId);
      if (account) {
        this.onChangeAccountAt(account);
      }
    });
  }
  // private subscribeClientFilter(): Subscription {
  //   return this.store.pipe(
  //     select(selectMainFilterClient)
  //   ).subscribe(client => {

  //     this.clientFilter = client[0];

  //   });
  // }

  private subscribeFilters(): Subscription {
    return this.store
      .pipe(
        select(selectMainClients),
        filter((clients) => !!clients.length),
        withLatestFrom(
          // combineLatest(
          //   this.store.pipe(select(selectMainFilterSelectedClient)),
          //   this.store.pipe(select(selectMainFilterSelectedAccount))
          // )
          combineLatest([
            this.store.pipe(select(selectMainFilterSelectedClient)),
            this.store.pipe(select(selectMainFilterSelectedAccount)),
          ])
        )
      )
      .subscribe(([clients, [clientFilter, accountFilter]]) => {
        if (!!clientFilter && !!accountFilter) {
          const client = clients.find(
            (client) => client._id === clientFilter._id
          ),
            account = client.accounts.find(
              (account: Account) => account._id === accountFilter._id
            );

          this.store.dispatch(
            new SetMainFilterAction({
              client: [client],
              account: !account
                ? []
                : [{ ...account, display: this.formatDropdownLabel(account) }],
            })
          );
        }

        if (!!clientFilter && !accountFilter) {
          const client = clients.find(
            (client) => client._id === clientFilter._id
          ),
            account = !!client.accounts.length ? client.accounts[0] : undefined;

          this.store.dispatch(
            new SetMainFilterAction({
              client: [client],
              account: !account
                ? []
                : [{ ...account, display: this.formatDropdownLabel(account) }],
            })
          );
        }

        if (!clientFilter && !accountFilter) {
          const client = clients[0],
            account = !!client.accounts.length ? client.accounts[0] : undefined;
          // this._changeDetectorRef.detectChanges();
          this.store.dispatch(
            new SetMainFilterAction({
              client: [client],
              account: !account
                ? []
                : [{ ...account, display: this.formatDropdownLabel(account) }],
            })
          );
        }
      });
  }

  private subscribeScrollToTop(): Subscription {
    return this.router.events.subscribe((event) => {
      if (!!this.scrollTarget && event instanceof NavigationEnd) {
        this.scrollTarget.nativeElement.scrollIntoView();
        this.showScrollToTop$.next(false);
      }
    });
  }

  /**
   * This method accounts for changing account filter while outside a feature
   * by resetting feature data and loading new dates. Feature itself handles the rest.
   */
  private subscribeAccountChange(): Subscription {
    return this.store
      .pipe(
        select(selectMainFilterSelectedAccount),
        distinctUntilChanged(isEqual)
      )
      .subscribe((account) => {
        if (!account) {
          this.store.dispatch(new ResetValuationsDataAction());
          this.store.dispatch(new ResetValuationsFilterAction());
          this.store.dispatch(new ResetReportsDataAction());
          /**
           * Reset Transactions and Statements mobile data if account is cleared
           * This is more of a hack in order to not break existing data loading logic
           * and accommodate (semi)infinite scroll
           */
          this.store.dispatch(new ResetTransactionsMobileData());
          this.store.dispatch(new ResetTransactionsMobilePagination());
          this.store.dispatch(new ResetStatementsAction());
          this.store.dispatch(new ResetDocumentsAction());
        }
      });
  }

  private subscribeScreenHeight(): Subscription {
    return this.resize.change$
      .pipe(map((change) => change.height))
      .subscribe(this.screenHeight$);
  }

  private subscribeIsMobile(): Subscription {
    return this.resize.mobile$.subscribe(this.isMobile$);
  }

  private subscribeHeroSize(): Subscription {
    return combineLatest([
      this.isMobile$,
      this.resize.filters$,
      this.showFilter$,
      this.showHeader$,
    ])
      .pipe(
        map(([isMobile, filters, showFilter, showHeader]) => {
          if (showFilter) {
            return isMobile ? filters * 50 + 180 : 180;
          } else {
            return isMobile ? filters * 50 + 100 : showHeader ? 180 : 100;
          }
        })
      )
      .subscribe(this.heroSize$);
  }

  /**
   * Sets scroll container height based on device
   */
  private subscribeMobileScrollHeight(): Subscription {
    return this.isMobile$
      .pipe(
        map((isMobile) =>
          isMobile ? "calc(100vh - 135px)" : "calc(100vh - 90px)"
        )
      )
      .subscribe(this.mobileScrollHeight$);
  }

  /**
   * Load Page Notes
   */
  private subscribePageNotes(): Subscription {
    return this.store
      .pipe(
        select(selectAuthLoggedIn),
        filter((logged) => !!logged)
      )
      .subscribe(() => {
        this.store.dispatch(new LoadPageNotesAction());
      });
  }

  private checkBrowserVersion(): void {
    if (checkBrowserVersion()) {
      // this.store.dispatch(new AddWarningToastAction(
      //   'To ensure the highest level of security, and an enhanced online experience, ' +
      //   'Investor Portal has been optimized for use with the latest version of the following internet browsers – ' +
      //   'Google Chrome, Mozilla Firefox, Microsoft Edge and Safari. We recommend downloading the most recent version of these browsers.',
      //   '',
      //   { icon: 'warning', showCloseButton: true }
      // ));
      //}
      this._toasterService.launchAlertWarning(
        "To ensure the highest level of security, and an enhanced online experience, " +
        "Investor Portal has been optimized for use with the latest version of the following internet browsers – " +
        "Google Chrome, Mozilla Firefox, Microsoft Edge and Safari. We recommend downloading the most recent version of these browsers.",
        "",
        ActionsCDK.warning
      );
    }
  }
}
